module.exports = __webpack_public_path__ + "img/2025-09-19d_6.f9d61ae5.jpg";